import { merge } from 'lodash';
import { getBaseImpressionEvent } from './base';

interface BqTestimonialsCardIsShownParams {
    testimonialId: string;
    pageName: string;
    sellerId: string;
    certifiedPartner?: {
        id: string;
        name: string;
    };
}

export const bqTestimonialsCardIsShown = ({
    testimonialId,
    pageName,
    certifiedPartner,
    sellerId,
}: BqTestimonialsCardIsShownParams) =>
    merge({}, getBaseImpressionEvent('testimonials_card_is_shown'), {
        page: {
            name: pageName,
            element: {
                type: 'window',
            },
        },
        seller: {
            id: sellerId,
        },
        certified: {
            partner: certifiedPartner,
        },
        testimonial: {
            id: testimonialId,
        },
        sub_group: 'testimonials',
    });
